module.exports = __webpack_public_path__ + "img/账号一体化.ab82a7ae.png";